import { Typography } from 'antd';

const { Text } = Typography;

const RewardsRate = ({ rewards }) => {
  const { rewardsConfig } = rewards || {};

  const generalRewardsRate = rewardsConfig?.rewardsRate;
  const hasCategoryRewards = rewardsConfig?.categoryRewardsRate;
  const hasDynamicRewards = rewardsConfig?.categoryName === 'DYNAMIC';

  if (hasDynamicRewards) {
    return <div data-testid="dynamic-rewards">Dynamic</div>;
  }

  // Gas, Travel, and Dining purchases > Gas, Travel, and Dining
  const categoryDescription =
    !hasDynamicRewards && rewardsConfig?.categoryName ? (
      rewardsConfig?.categoryName.replace('purchases', '')
    ) : (
      <Text type="secondary" italic>
        Categories Pending
      </Text>
    );

  const categoryRewardsRate = rewardsConfig?.categoryRewardsRate ? (
    rewardsConfig?.categoryRewardsRate
  ) : (
    <Text type="secondary" italic>
      Pending
    </Text>
  );

  if (!hasDynamicRewards && hasCategoryRewards) {
    return (
      <div data-testid="category-rewards-rates">
        {categoryDescription} - {categoryRewardsRate}%
        <br />
        All other purchases - {generalRewardsRate}%
      </div>
    );
  }

  return <div data-testid="general-rewards-rate">{generalRewardsRate}%</div>;
};

export default RewardsRate;
